<template>
  <div class="main-video"
       v-if="videoId"
       :class="{'main-video--modal': isModal}"
       @click="toggleVideoPlaying(true)"
       v-intersect="{
         callback: isVisible
       }"
  >
    <iframe ref="video"
            id="player"
            v-if="playVideo"
            allowfullscreen=""
            allow="autoplay; encrypted-media"
            :src="`https://www.youtube.com/embed/${videoId}?rel=0&amp&enablejsapi=1;showinfo=0&amp;autoplay=1`"
            frameborder="0"></iframe>
    <div v-else>
      <picture class="main-video__picture">
        <source
          :srcset="`https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`"
          media="(max-width: 480px)"
        >
        <img
          class="main-video__img"
          :src="`https://img.youtube.com/vi/${videoId}/${previewQuality}.jpg`"
          alt="youtube-img"
        >
      </picture>

      <div v-if="hasOverlayContentSlot" class="overlay-content">
        <slot name="overlay-content">
        </slot>
      </div>

      <div class="play-video-btn" :class="{'play-video-btn--plain': plainButton}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainVideo',
  data () {
    return {
      playVideo: false
    }
  },
  props: {
    videoId: {
      type: String,
      default: '',
      required: true
    },
    plainButton: Boolean,
    isModal: Boolean,
    previewQuality: {
      type: String,
      default: 'sddefault'
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasOverlayContentSlot () {
      return !!this.$scopedSlots['overlay-content']
    }
  },
  methods: {
    toggleVideoPlaying (bool) {
      this.playVideo = bool
    },
    isVisible (isVisible) {
      if (!isVisible) this.toggleVideoPlaying(isVisible)
    }
  },
  watch: {
    // Swiper can keep the iframe visible while the slide is no longer active.
    isActive (newVal) {
      if (!newVal) {
        this.toggleVideoPlaying(false)
      }
    }
  }
}
</script>

<style scoped lang="sass">

.main-video
  width: 100%
  background-color: #000
  position: relative
  overflow: hidden
  cursor: pointer
  padding-bottom: 56.25%
  height: 0

  &.main-video--modal
    padding-bottom: 50vh

    +mmin($tablet)
      padding-bottom: 42vh

  &__img
    width: 100%
    cursor: pointer
    object-fit: contain
    top: 50%
    transform: translateY(-50%)
    position: absolute

  iframe
    position: absolute
    height: 100%
    width: 100%
    top: 0
    left: 0

.main-video__picture
  display: flex
  justify-content: center

// video btn
.play-video-btn
  width: 60px
  height: 60px
  background-color: $main-color
  box-shadow: 0 0 30px rgba( 0,0,0,0.6 )
  z-index: 1
  border-radius: 50%
  cursor: pointer
  position: absolute
  top: 50%
  left: 50%
  transform: translate3d( -50%, -50%, 0 )
  transition: all .3s

  &:hover
    background-color: $text-color
    opacity: .9

  &:before
    content: ''
    position: absolute
    border-style: solid
    border-width: 10px 0 10px 18px
    border-color: transparent transparent transparent #fff
    top: 50%
    left: 50%
    transform: translate3d( -40%, -50%, 0 )
    transition: all .3s

  &--plain
    border: 3px solid #fff
    background-color: transparent

    &:hover
      border-color: darken(#fff, 15%)
      background-color: transparent

      &:before
        border-color: transparent transparent transparent darken(#fff, 15%)

.overlay-content
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 100%
</style>
